import React from 'react';

import MashaLogo from '../../../assets/images/logo-masha.png';

const Home: React.FC = () => (
  <img src={MashaLogo} alt="Logo" height="50px" />
);

export default Home;
